import StoreDBManger from "../../../../util/StoreDBManger.js";
import { getTrainTypeTitle } from "../util/trainDialogUtil.js";

// 情况二、现场学习-签退页面，有学员未签退时，先签退监督人
export default {
    name: "LoginForceOutDialog",
    props: {
        propDialogVisible: Boolean,
        propDialogObject: Object,
    },
    components: {},
    data() {
        return {
            dialogVisible: false, // 弹窗是否显示
        };
    },
    watch: {
        propDialogVisible: {
            immediate: true,
            handler(value) {
                this.dialogVisible = value;
            },
        },
        propDialogObject: {
            immediate: true,
            handler(value) {
                if (value) {
                }
            },
            deep: true,
        },
    },
    computed: {},
    methods: {
        /**
         * 关闭弹窗
         */
        closeDialog() {
            this.$emit("update:propDialogVisible");
            this.$emit("cancel-back");
        },
        /**
         * 取消弹窗
         */
        handleClose() {
            // 0或空为签到, 1抽验, 2签退
            StoreDBManger.saveDataToLocalStorage(StoreDBManger.storageKeys.SELECT_SIGN_TYPE, 2);
            location.reload();
        },
        /**
         * 确认退出 cancel-back
         */
        loginOut() {
            this.$emit("call-back");
            this.$emit("update:propDialogVisible"); // 关闭弹窗
        },
    },
};
